




import {
  defineComponent,
  onMounted,
  toRefs,
  computed,
  ref
} from '@nuxtjs/composition-api'
import { getLiveStaticUrl } from '~/utils/static'

export default defineComponent({
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const { id } = toRefs(props)

    const hasError = ref(false)

    const imgSrc = computed(() => {
      if (hasError.value) {
        return getLiveStaticUrl(`/static/images/web/xyma_small/xymastore.png`)
      }

      return imageLink.value
    })

    const imageLink = computed(() =>
      getLiveStaticUrl(`/static/images/web/xyma_small/cat-${id.value}.png`)
    )

    onMounted(() => {
      const img = new Image()
      img.onerror = () => {
        hasError.value = true
      }

      img.crossOrigin = 'Anonymous'
      img.src = getLiveStaticUrl(
        `/static/images/web/xyma_small/cat-${id.value}.png`
      )
    })
    return { imgSrc, hasError, imageLink }
  }
})
